import { observer } from 'mobx-react';

import useStores from 'hooks/useStores';
import Button from 'components/@common/Button';

import { CARD_EDIT_TARGET_INDEX, PAGE_LIST } from 'constants/';
import * as S from './styles';

function PaymentInfo() {
  const { CardWallet, AppHandler } = useStores();

  const onClickAddCardButton = () => {
    CardWallet.setEditCardIndex(CARD_EDIT_TARGET_INDEX.NEW);
    AppHandler.setAppLocation(PAGE_LIST.CARD_LIST);
  };

  const onClickCancelButton = (event) => {
    AppHandler.handleCancel(event);
  };

  return (
    <>
      <S.PaymentInfo>
        <S.PaymentLabel>가격</S.PaymentLabel>
        <S.PaymentPrice>{CardWallet.amountPaid}</S.PaymentPrice>
      </S.PaymentInfo>

      <div className="button-container flex">
        <Button type="primary" width="50%" onClick={onClickAddCardButton}>
          카드 추가/관리
        </Button>
        <Button type="warning" width="50%" onClick={onClickCancelButton}>
          결제 취소
        </Button>
      </div>
    </>
  );
}

export default observer(PaymentInfo);
